module.exports = __webpack_public_path__ + "static/media/18ECA30.341bf7fb.jpg";